import posthog from "posthog-js";
import { ErrorBoundary, type FallbackProps } from "react-error-boundary";
import { Button } from "@/components/ui/button";

function DefaultFallback({ error, resetErrorBoundary }: FallbackProps) {
    return (
        <div role="alert" className="flex flex-col items-center justify-center h-full gap-4 p-8 text-center">
            <p className="text-base-red-60 font-medium">Something went wrong</p>
            <p className="text-sm text-base-grey-60">{error.message}</p>
            <Button variant="ghost" onClick={resetErrorBoundary} className="text-sm underline text-base-grey-80">
                Try again
            </Button>
        </div>
    );
}

interface Props {
    children: React.ReactNode;
    fallback?: React.ComponentType<FallbackProps>;
}

export function PostHogErrorBoundary({ children, fallback: Fallback = DefaultFallback }: Props) {
    return (
        <ErrorBoundary
            FallbackComponent={Fallback}
            onError={(error, info) => {
                posthog.captureException(error, { $exception_component_stack: info.componentStack });
            }}
        >
            {children}
        </ErrorBoundary>
    );
}
